import { atom } from 'jotai';

export const searchValueAtom = atom('');
